export default __webpack_public_path__ + "static/media/GstOptionScreen@2x.9abecd1a.png";